import * as React from "react";
import { Link } from "react-router-dom";
import { formatDate } from "app/utils/filters";
import { ColumnConfig } from "../ConfigurableTable";
import SubmitBatchWithdrawalsButton from "./SubmitBatchWithdrawalsButton";

export type GqlWithdrawalBatch = {
  id: string;
  created_at: string;
  status: string;
  comment: string;
};

const columnConfigFactory = (onSubmit: () => void): Array<ColumnConfig> => {
  return [
    {
      name: "Created At",
      render: (batch: GqlWithdrawalBatch) => formatDate(batch.created_at)
    },
    {
      name: "Id",
      render: (batch: GqlWithdrawalBatch) => (
        <Link
          className="blueLink"
          to={`/snapscan/settlements/withdrawals/batches/${batch.id}/summary`}
        >
          {batch.id}
        </Link>
      )
    },
    {
      name: "Status",
      render: (batch: GqlWithdrawalBatch) => batch.status
    },
    {
      name: "Comment",
      render: (batch: GqlWithdrawalBatch) => batch.comment
    },
    {
      name: "Action",
      render: (batch: GqlWithdrawalBatch) =>
        batch.status === "pending" ? (
          <SubmitBatchWithdrawalsButton
            batchId={batch.id}
            onSubmit={onSubmit}
          />
        ) : null
    }
  ];
};

export default columnConfigFactory;
